var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"inline-flex list-none",attrs:{"tabindex":null,"aria-disabled":true}},[_c('span',{staticClass:"text-sm text-black-900 mt-1 font-semibold w-full block text-left rtl:text-right whitespace-nowrap p-2"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }